import React from 'react'
import DepartmentSelect, { DepartmentItem } from './DepartmentSelect'
import MultiSelect from './MultiSelect'
import { compact } from 'lodash'
import { IDepartment } from '@api/types'
interface MultiDepartmentSelectProps {
  values: IDepartment[]
  onChange: (items: IDepartment[]) => void
  title?: string
}

export default function MultiDepartmentSelect({
  values,
  onChange,
  title = 'Departments',
}: MultiDepartmentSelectProps) {
  return (
    <MultiSelect
      title={title}
      values={values.map((d) => (
        <DepartmentItem key={d.id} type="value" data={d} />
      ))}
      select={
        <DepartmentSelect
          itemDisabled={(dept) => !!values.find(({ id }) => id === dept.id)}
          onChange={(dept) =>
            dept && values.find(({ id }) => id === dept.id)
              ? onChange(values.filter(({ id }) => id !== dept.id))
              : onChange(compact([...values, dept]))
          }
          placeholder="Add"
          buttonProps={{ iconName: 'plus', minimal: true, blue: true }}
          value={null}
          multi
        />
      }
      onRemove={(id: string) => onChange(values.filter((av) => av.id !== id))}
    />
  )
}
